export default {"src":"/_next/static/media/userActive.5590beb4.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};